<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">
      Квартира {{ apartment.number }}
      <router-link class="btn btn-primary" :to="{ name: 'apartment-edit', params: { apartment_id: apartment.id }}">Редактировать квартиру</router-link>
    </h2>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'block-details', params: { block_id: $route.params.block_id } }">← Назад к Квартирам</router-link>
    </div>

    <div v-if="false" class="row">
      <div class="col-md-6">

        <!-- Full name -->
        <div class="form-group">
          <label>Полный адрес</label>
          <p>{{ apartment.full_name }}</p>
        </div>

      </div>
      <div class="col-md-6">

        <!-- Number -->
        <div class="form-group">
          <label>Номер квартиры</label>
          <p>{{ apartment.number }}</p>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <router-view :apartment-id="apartment.id"></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import { getApartment } from '@/services/apartment.service'

export default {
  name: 'apartment-details',
  data () {
    return {
      apartment: {
        id: null,
        number: '',
        full_name: ''
      }
    }
  },
  mounted () {
    if (this.$route.params.apartment_id !== undefined) {
      this.apartment.id = this.$route.params.apartment_id

      getApartment(this.apartment.id).then((response) => {
        this.apartment = response.data
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// ApartmentDetails.vue?3e45cfa2